import {Box} from '@customink/pigment-react';
import {styled} from '@mui/material/styles';

const StyledRecoBox = styled(Box)(({theme}) => ({
  [theme.breakpoints.up('md')]: {
    gap: '1rem'
  },
  '& .MuiCard-root:hover': {
    boxShadow: 'none !important'
  },
  display: 'grid',
  gap: '0.5rem',
  gridTemplateColumns: 'repeat(4, 1fr)',
  marginTop: '1rem'
}));

export default StyledRecoBox;
